import PropTypes from 'prop-types';
import React from 'react';
import { CheckCircle } from 'react-feather';
import FeedbackScreenTitle from '../common/feedback-screen-title';

const FeedbackThankYouScreen = ({ message }) => (
  <div className="px-5 py-8 flex flex-col items-center text-center gap-4">
    <CheckCircle size={48} className="feedback-brand-text" />
    <FeedbackScreenTitle title={message} />
  </div>
);

FeedbackThankYouScreen.propTypes = {
  message: PropTypes.string,
};

FeedbackThankYouScreen.defaultProps = {
  message: '',
};

export default FeedbackThankYouScreen;
